var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center w-100"},[_c('h3',{staticStyle:{"color":"#fff"}},[_vm._v(_vm._s(_vm.message)+" "),_c('i',{staticClass:"fa fa-spinner fa-spin"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }